/** @format */

import PropertyWidget from 'components/PropertyWidget';

import {CalcMethod} from 'components/PropertyWidget/model';

import {WIDGETS_LIST} from '../../constants/widgets';
import isStubChartId from '../../helpers/isStubChartId';
import getWidgetIcon from '../../helpers/getWidgetIcon';
import StubWidget from '../stub-widget';
import {AnalyticGoalFromQuery} from '../../models/api';
import {ChartIds} from '../../models/chartIds';
import {Space, WidgetConditionsList} from '../../models/spaces';
import {WidgetBlock} from '../../models/widgets';
import {addCrIdsToBlocks} from '../dashboard-wrap/utils';
import {WidgetWorkspace} from '../widgets/widget-workspace';
import getUsedWidgets from './helpers/getUsedWidgets';
import getWidgetsBlockByChartId from './helpers/getWidgetsBlockByChartId';
import {WidgetsListRoot as Root} from './style';

interface Props {
  space: Space;
  widgetBlocks: WidgetBlock[];
  widgetConditions: WidgetConditionsList;
  analyticGoals: ReadonlyArray<AnalyticGoalFromQuery>;
  onCrConfirm: (widgetId: ChartIds, aId: number | string, bId: number | string) => void;
  onChangeTitle: (value: string) => void;
  onMethodClick: (widgetId: ChartIds, method: CalcMethod) => void;
  onScaleClick: (widgetId: ChartIds, scale: boolean) => void;
  onSwitcherClick: (widgetId: ChartIds) => void;
  onConfirmMenuSettings: (space: Space) => void;
  onRemoveSpace: () => void;
}

const WidgetsWrap = ({
  space,
  widgetBlocks,
  onChangeTitle,
  onMethodClick,
  onScaleClick,
  onSwitcherClick,
  onConfirmMenuSettings,
  widgetConditions,
  onRemoveSpace,
  analyticGoals,
  onCrConfirm,
}: Props) => {
  const usedWidgets = getUsedWidgets(space);
  const selected = space.chartSelected.current;
  const settings = space.widgetsSettings;

  return (
    <Root>
      <WidgetWorkspace
        space={space}
        widgetBlocks={addCrIdsToBlocks(widgetBlocks, space)}
        onChangeTitle={onChangeTitle}
        onConfirmMenuSettings={onConfirmMenuSettings}
        onRemoveSpace={onRemoveSpace}
      />
      {usedWidgets.map(id => {
        const {label, id: blockId, color: colorData} = getWidgetsBlockByChartId(widgetBlocks, id);

        const color = colorData.main ? colorData.main : colorData[id] || '';

        if (isStubChartId(id)) {
          return (
            <StubWidget
              key={id}
              chartId={id}
              color={color}
              selected={selected.includes(id)}
              onSwitcherClick={() => onSwitcherClick(id)}
            />
          );
        }

        return (
          <PropertyWidget
            key={id}
            data={WIDGETS_LIST[id]}
            color={color}
            widgetSettings={settings[id]}
            selected={selected.includes(id)}
            categoryLabel={label}
            blockId={blockId}
            CategoryIcon={getWidgetIcon(blockId, color)}
            showCondition={widgetConditions[id] || 'common'}
            analyticGoals={analyticGoals}
            onCrConfirm={(aId, bId) => onCrConfirm(id, aId, bId)}
            onMethodClick={method => onMethodClick(id, method)}
            onScaleClick={scale => onScaleClick(id, scale)}
            onSwitcherClick={() => onSwitcherClick(id)}
          />
        );
      })}
    </Root>
  );
};

export default WidgetsWrap;
